export type InferredEventStyle = {
  type: string;
  label: string;
  color: string;
  description: string;
};

export const INFERRED_EVENT_STYLES: InferredEventStyle[] = [
  { type: 'arrival', label: 'Arrival', color: '#2563eb', description: 'Train inferred to have reached a station or platform.' },
  { type: 'departure', label: 'Departure', color: '#0f766e', description: 'Train inferred to have left a station or platform.' },
  { type: 'pass_through', label: 'Pass-through', color: '#64748b', description: 'Station crossing inferred without a supported dwell.' },
  { type: 'turnback', label: 'Turnback', color: '#f97316', description: 'Train inferred to have reversed or changed its expected service pattern.' },
  { type: 'disappearance', label: 'Disappearance', color: '#dc2626', description: 'Train stopped appearing in collected observations.' },
  { type: 'reappearance', label: 'Reappearance', color: '#16a34a', description: 'Train returned after an inferred disappearance.' },
  { type: 'destination_change', label: 'Destination change', color: '#7c3aed', description: 'Observed destination changed during the run.' },
  { type: 'other', label: 'Other', color: '#334155', description: 'Another inferred event type without a dedicated color.' },
];

const STYLE_BY_TYPE = new Map(INFERRED_EVENT_STYLES.map(style => [style.type, style]));

export function inferredEventStyle(eventType: string): InferredEventStyle {
  return STYLE_BY_TYPE.get(eventType) ?? (STYLE_BY_TYPE.get('other') as InferredEventStyle);
}
